import { useQuery } from '@tanstack/react-query';
import SafeImage from '@ui/SafeImage';
import { getCauseById } from '@util/firestore/products';
import { ProductDocument } from '@models/product';
import Link from 'next/link';
import React from 'react';
import r2r from '/src/i/auctions/r2r.png';
import vmx_logo from '/src/i/auctions/vmx_logo.webp';
const AuctionCause = ({ product }: { product: ProductDocument }) => {
  const { data: causeDoc } = useQuery({
    queryKey: ['cause'],
    queryFn: () => getCauseById(product?.cause ?? ''),
    enabled: !!product.cause,
  });
  if (!causeDoc) return null;
  return (
    <>
      <div className="flex items-center gap-[2rem] rounded-brand border-[1px] px-[1.6rem] py-[2rem]">
        {causeDoc.id === 'veteran_mx' ? (
          <SafeImage
            alt="auction cause logo"
            className="h-[10rem] w-[10rem] object-contain"
            src={vmx_logo}
            width={600}
            height={600}
            key={causeDoc.id}
          />
        ) : (
          <SafeImage
            alt="auction cause logo"
            className="h-[10rem] w-[10rem] object-contain"
            src={r2r}
            width={600}
            height={600}
            key={causeDoc.id}
          />
        )}

        <div className="flex flex-col gap-[0.4rem]">
          <span className="text-[1.6rem] font-bold text-gray-800">
            This auction benefits {causeDoc.name}
          </span>
          <Link
            href={causeDoc.link}
            target="_blank"
            className="text-[1.6rem] text-gray-500 underline"
          >
            Learn more
          </Link>
        </div>
      </div>
      <div className="relative h-[14rem] w-full">
        <SafeImage src={causeDoc.img} alt={''} fill />
      </div>
    </>
  );
};

export default React.memo(AuctionCause);
